module.exports = __webpack_public_path__ + "media/svg-new/icon-matematica-d3889c85.svg";